import { useNavigate } from 'react-router-dom'

import { XIcon } from 'lucide-react'
import { Button } from '~/shadcn/ui/button/button'
import { cn } from '~/shadcn/lib/utils'
import { CheckCircleIcon } from '~/@mid_ui/icons/CheckCircleIcon'
import { useRegistrationGiftBanner } from './useRegistrationGiftBanner'

export function RegistrationGiftBanner() {
  const navigate = useNavigate()

  const { isVisible, activeCouponType, closeBanner } =
    useRegistrationGiftBanner()
  const isAbFix = activeCouponType === 'ab_fix'
  const isAbPercentual = activeCouponType === 'ab_percentual'

  const handleInvestNow = () => {
    navigate('/projects')
  }

  if (!isVisible) return null

  return (
    <div className="flex justify-between flex-row w-full bg-[#006EF0] px-3 pt-3 pb-4">
      <div
        className={cn(
          'flex flex-col lg:flex-row gap-2 items-center justify-between w-full'
        )}>
        <div className="flex flex-row w-full gap-2 items-center">
          <CheckCircleIcon
            className="self-start"
            strokeColor="#000"
            fillColor="#FFF"
          />

          <div className="flex flex-col gap-3 text-white">
            {isAbFix && (
              <>
                <p>
                  Nezabudnite využiť darček 20€ k prvej investícii. Ponuka platí
                  do 15.7.2024!
                </p>
                <p className="text-sm leading-[21px] font-medium">
                  Staňte sa súčasťou platformy s najvyššími výnosmi na
                  Slovensku.{' '}
                  <b>
                    K prvej investícii získajte darček 20€ pre nových členov.
                  </b>
                </p>
              </>
            )}
            {isAbPercentual && (
              <>
                <p>
                  Limitovaná ponuka pre nových členov do 15.7.2024 Získajte o
                  0,5% vyšší výnos!
                </p>
                <p className="text-sm leading-[21px] font-medium">
                  Nezabudnite!{' '}
                  <b>Ako nový člen platformy získate o 0,5% vyšší výnos</b> ku
                  všetkým investíciám, ktoré urobíte do 15.7.2024
                </p>
              </>
            )}
          </div>
        </div>
        <Button
          variant="outline"
          className="text-white border-white hover:text-white hover:border-white"
          onClick={handleInvestNow}>
          Investovať teraz
        </Button>
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="self-baseline"
        onClick={closeBanner}>
        <XIcon className="text-white w-[17px] h-[17px]" />
      </Button>
    </div>
  )
}
